import '../App.css';
// import { Link } from 'react-router-dom'

import { Text } from './Text'
import { Select } from './Select';

export const TextContainer = ({ footerHeight, menuHeight }) => {

    return (
        <div className='text-container' style={{ minHeight: 100 - footerHeight + menuHeight + 'vh'  }}>
            {/* <Link to='/news'>
                <h1 className='blink text'>¡ultimas noticias!</h1>
            </Link> */}
           
            <Select />
            <Text />
        </div>
    )
}